


































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateItem from "./createitem.vue";
import EditItem from "./edititem.vue";

class PageUserRequest extends PageRequest {
  keyword: string;
}

@Component({
  components: { CreateItem, EditItem },
})
export default class Items extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  tableHeight: number = 300; //表格高度

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  get list() {
    return this.$store.state.items.list;
  }
  get loading() {
    return this.$store.state.items.loading;
  }
  changeSort(key) {
    if (key.order != "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  create() {
    this.createModalShow = true;
  }
  cancel() {
    (this.$refs.itemDetailForm as any).resetFields();
    this.$emit("input", false);
  }
  pageChange(page: number) {
    this.$store.commit("items/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("items/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "items/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.items.pageSize;
  }
  get totalCount() {
    return this.$store.state.items.totalCount;
  }
  get currentPage() {
    return this.$store.state.items.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo")
    },
    {
      title: this.L("ParentName"),
      key: "parentId",
      sortable: true,
    },
    {
      title: this.L("Name"),
      key: "name",
      sortable: true,
    },
    {
      title: this.L("Encode"),
      key: "enCode",
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      sortable: true,
    },
    {
      title: this.L("IsEnable"),
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("items/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "items/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
  }
  data() {
    return {
      tableHeight: 600,
    }
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.tableHeight = window.innerHeight - 380;
    } else {
      this.tableHeight = window.innerHeight - 420;
    }
  }
}
